import { IOfferCard, EMediaType, IMedia } from '../../../../types';

export const preparePhotos = ({ photos: offerPhotos, isBookedFromDeveloper }: IOfferCard): IMedia[] => {
  const sortedPhotosByDefault = [...offerPhotos].sort((a, b) => Number(b.isDefault) - Number(a.isDefault));

  return sortedPhotosByDefault.map(({ isLayout, thumbnail2Url }) => ({
    type: isLayout ? EMediaType.Layout : EMediaType.Photo,
    src: thumbnail2Url,
    withBookedOverlay: isBookedFromDeveloper,
  }));
};
